import camelcase from 'camelcase-keys';
import decamelize from 'decamelize-keys';

export const camelcaseKeys = (data: Record<string, unknown>) => camelcase(data, { deep: true });
export const decamelizeKeys = (data: Record<string, unknown>) => decamelize(data, { deep: true });
